import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps
} from '@mui/material';

export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;

export const ToggleButtonGroup = (props: Readonly<ToggleButtonGroupProps>) => (
  <MuiToggleButtonGroup {...props} />
);
